let portfolioData=[
    {
        title: "Attendlytical",
        description: "Student Attendance Tracking App Using Facial Recognition",
        url: "/portfolio/attendlytical",
        period: "March 2020 - October 2020 (7 months)",
        images:[
            "images/portfolio/attendlytical/MainPage.png",
            "images/portfolio/attendlytical/AttendanceList.png",
            "images/portfolio/attendlytical/AttendanceRoom.png",
            "images/portfolio/attendlytical/AttendanceRecord.png",
            "images/portfolio/attendlytical/Dataset.png",

            "images/portfolio/attendlytical/FaceDetection.png",
            "images/portfolio/attendlytical/LandmarkDetection.png",

        ],
        category: "Web Application (Full Stack)",
        mode: "Individual (FYP)",
        teamMember: [
            "Chai Cheah Wen"
        ],
        features: [
            "Apply Facial Recognition Deep Learning Approach For Web-Based Attendance",
            "Student-Lecturer Daily Attendance Routine",
            "Create Class/Enrol Class",
            "Dataset Upload By Students",
            "F2F/Remote Attendance",
            "Real-Time Recognition with Annotation",
            "Attendance Record Visualization with Timestamp",
            "Attendance Data Excel Export"
        ],
        tools: {
            core: "face-api.js, ReactJS, AntDesign, NodeJS, Apollo Server & Client, GraphQL",
            programming: "Javascript",
            database: "MongoDB",
        },
        website: "https://attendlytical.netlify.app",
        githubLink: "https://github.com/CodeShareCW/Attendlytical",
        demoLink: "https://www.youtube.com/embed/5032gwfAi5g",
        credits: [
            {
                displayName: "face-api.js",
                sourceLink: "https://github.com/justadudewhohacks/face-api.js/"
            }
        ]
    },
    {
        title: "Automatic License Plate Recognition (ALPR) Application",
        description: "A desktop app for detect license plate and OCR (Internship)",
        url: "/portfolio/ALPR",
        period: "Dec 2020 - Jan 2020 (1 month)",
        images:[
            "images/portfolio/ALPR.png"

        ],
        category: "Desktop Application",
        mode: "Individual (Internship)",
        teamMember: [
            "Chai Cheah Wen (Programmer)"
        ],
        features: [
            "Perform license plate detection & OCR recognition",
            "Store the detected license plate into database with timestamp",
            "Display a list of top 5 recent carplate number on the right size",
            "Adjustable Window Size",
            "Adjustable Detection Threshold by Users"
        ],
        tools: {
            core: "OpenCV, Tensorflow, aiomysql, Kivy",
            programming: "Python",
            database: "MySQL",
        },
        website: "",
        githubLink: "https://github.com/CheahWen/ALPR",
        demoLink: "",
        credits: [
        ]
    },
    {
        title: "Hybrid App Of Attendance App",
        description: "A hybrid app using Flutter (Incomplete)",
        url: "/portfolio/FlutterAttendanceApp",
        period: "Jan 2020 - Feb 2020 (1 month)",
        images:[
            "images/portfolio/HybridApp.png"

        ],
        category: "Hybrid Application (Mobile & Web)",
        mode: "Individual (Internship)",
        teamMember: [
            "Chai Cheah Wen (Programmer)"
        ],
        features: [
            "Transform exisitng web portal of attendance system into hybrid app using Flutter",
        ],
        tools: {
            core: "Flutter, REST API",
            programming: "Dart, PHP",
            database: "MySQL",
        },
        website: "",
        githubLink: "",
        demoLink: "",
        credits: [
        ]
    },
    {
        title: "Alzheimer Daily Helper",
        description: "Mobile app for Alzheimer patients",
        url: "/portfolio/AlzheimerDailyHelper",
        period: "Oct 2019 - Sep 2020 (3 months)",
        images:[
            "images/portfolio/adh/MainPage.png",
            "images/portfolio/adh/Login.png",
            "images/portfolio/adh/Register.png",
            "images/portfolio/adh/Interface.png",
            "images/portfolio/adh/HelloToday.png",
            "images/portfolio/adh/Reminder.png",
            "images/portfolio/adh/Caregiver.png",
            "images/portfolio/adh/FaceDataset.png",
            "images/portfolio/adh/Training.png",
            "images/portfolio/adh/ISay.png",
            "images/portfolio/adh/Duet.png",
            "images/portfolio/adh/Gamification.png",
            "images/portfolio/adh/Achievement.png"
        ],
        category: "Mobile Application",
        mode: "Individual",
        teamMember: [
            "Chai Cheah Wen (Leader & Programmer)",
            "Ngieng Chai Wen (Designer & Documentation)",
            "Puan Alma Nalita (Tester & Documentation)"
        ],
        features: [
            "Facebook Login",
            "Caregiver Utility",
            "Facial Recognition using Viola Jones based Face Detector (Haar) & LBPH Feature Extractor",
            "Daily Routine Notifications",
            "Flash Card Event Record",
            "2 Mini Games for Brain Training",
            "App Gamification (Coins & Leaderboard & Achievement)"
        ],
        tools: {
            core: "Unity3D, FacebookSDK",
            programming: "C#",
            database: "MongoDB",
        },
        website: "",
        githubLink: "https://github.com/CodeShareCW/Alzheimer-Daily-Helper",
        demoLink: "https://www.youtube.com/embed/L7tRtDABuiI",
        credits: [
            {
                displayName: "FacebookSDK For Unity",
                sourceLink: "https://developers.facebook.com/docs/unity/"
            },
            {
                displayName: "OpenCV + Unity",
                sourceLink: "https://assetstore.unity.com/packages/tools/integration/opencv-plus-unity-85928"
            },
            {
                displayName: "3D Clock",
                sourceLink: "https://assetstore.unity.com/packages/3d/props/interior/clock-4250"
            },
            {
                displayName: "Simple Android Notification",
                sourceLink: "https://assetstore.unity.com/packages/tools/integration/simple-android-notifications-free-68626"
            },
            {
                displayName: "SSTools",
                sourceLink: "https://github.com/sseasycode/SSTools/blob/master/SSTools.unitypackage"
            },
            {
                displayName: "MongoDB C# Driver For Unity",
                sourceLink: "https://github.com/Julian23517/Unity-mongo-csharp-driver-dlls"
            }
        ]
    },
    {
        title: "Hierarchical Modelling",
        description: "Simple Hierarchical Modelling using OpenGL with Interaction",
        url: "/portfolio/HierarchicalModelling",
        period: "April 2019 - May 2019 (1 month)",
        images:[
            "images/portfolio/hierarchicalmodelling/MainPage.png",
            "images/portfolio/hierarchicalmodelling/WalkAnimation.png",
            "images/portfolio/hierarchicalmodelling/CamRotation.png",
            "images/portfolio/hierarchicalmodelling/CamRotation2.png",

        ],
        category: "Window 3D Application",
        mode: "Group",
        teamMember: [
            "Goh Chiang Cheng (Leader)",
            "Chai Cheah Wen (Programmer)"
        ],
        features: [
            "Body Control Using Keyboard",
            "Camera Rotation",
            "Animation",
            "Lighting (Directional, Ambient, Diffuse, Specular)",
            "Material"
        ],
        tools: {
            core: "OpenGL",
            programming: "C++",
            database: "",
        },
        website: "",
        githubLink: "https://github.com/CodeShareCW/FCG-Hierarchical-Modelling",
        demoLink: "https://www.youtube.com/embed/Gpk4CowKrYo",
        credits: [
        ]
    },
    {
        title: "Mini Paint",
        description: "Simple Mini Paint using OpenGL with Interaction",
        url: "/portfolio/MiniPaint",
        period: "March 2019 - April 2019 (1 month)",
        images:[
            "images/portfolio/minipaint/MainPage.png",
            "images/portfolio/minipaint/Example.png",

        ],
        category: "Window 2D Drawing Application",
        mode: "Group",
        teamMember: [
            "Goh Chiang Cheng (Leader)",
            "Chai Cheah Wen (Programmer)"
        ],
        features: [
            "Simple Primitives Drawing (Dot, Straight Line, FreeHand, Circle, Ellipse, Triangle, Rectangle)",
            "Control using Mouse Motion",
            "Switch between Primitive using Menu",
            "Change Line Color Using Menu",
            "Change Background Color Using Menu",
            "Change Line Width using Keyboard"
        ],
        tools: {
            core: "OpenGL",
            programming: "C++",
            database: "",
        },
        website: "",
        githubLink: "https://github.com/CodeShareCW/FCG-Mini-Paint-Cpp-OpenGL",
        demoLink: "https://www.youtube.com/embed/hsWmjqL-li8",
        credits: [
        ]
    },
    {
        title: "VR Scene Walkthrough",
        description: "Google Cardboard VR Mobile Application using Unity3D",
        url: "/portfolio/VRSceneWalkthrough",
        period: "Feb 2020 - Feb 2020 (1 week)",
        images:[
            "images/portfolio/vrwalkthrough/MainPage.png",
            "images/portfolio/vrwalkthrough/RoomModel.png",
            "images/portfolio/vrwalkthrough/RenderModel.png",
            "images/portfolio/vrwalkthrough/Shading.png",
        ],
        category: "Mobile VR Application",
        mode: "Individual",
        teamMember: [
            "Chai Cheah Wen (Artist & Programmer)"
        ],
        features: [
            "VR Room Scene Environment",
            "Move with Head 45 Degree downward roughly",
            "Toggle Light & Fan On/Off using Pointer"
        ],
        tools: {
            core: "Blender, Unity3D",
            programming: "C#",
            database: "",
        },
        website: "",
        githubLink: "",
        demoLink: "https://www.youtube.com/embed/elhCcRYSWZU",
        credits: [
            {
                displayName: "VR SDK For Unity",
                sourceLink: "https://developers.google.com/vr/unity/download"
            }
        ]
    },
    {
        title: "Whacking Mole Game",
        description: "Whacking Mole Game using Hologram with Unity3D",
        url: "/portfolio/WhackingMole",
        period: "March 2020 - March 2020 (1 week)",
        images:[
            "images/portfolio/whackingmole/MainPage.png",
            "images/portfolio/whackingmole/Score.png",
        ],
        category: "3D Game",
        mode: "Group",
        teamMember: [
            "Looi Yao Wei (Programmer)",
            "Chai Cheah Wen (Programmer)"
        ],
        features: [
            "2 Player On Same PC",
            "Control Hammer using Keyboard",
            "Higher number of Score is the Winner"
        ],
        tools: {
            core: "Unity3D",
            programming: "C#",
            database: "",
        },
        website: "",
        githubLink: "",
        demoLink: "https://www.youtube.com/embed/rUjl3sK-_ik",
        credits: [
            {
                displayName: "Hologram Pyramid",
                sourceLink: "https://assetstore.unity.com/packages/tools/hologram-pyramid-61735"
            }
        ]
    },
    {
        title: "Leap Motion Portal",
        description: "A VR game to create portal with natural hand gesture using Leap Motion in Unity3D",
        url: "/portfolio/LeapMotionPortal",
        period: "March 2020 - March 2020 (1 week)",
        images:[
            "images/portfolio/leapmotion/MainPage.png",
            "images/portfolio/leapmotion/HandGesture.png",
        ],
        category: "3D VR Application",
        mode: "Group",
        teamMember: [
            "Goh Chiang Cheng (Programmer)",
            "Steven Yong Wei (Resource Assistant)",
            "Chai Cheah Wen (Documentation Assistant)"
        ],
        features: [
            "Open the Portal using Circular Natural Hand Gesture",
            "Close the Portal using Hand Clap",
            "Object Teleport To Other Side through the Portal"
        ],
        tools: {
            core: "Unity3D",
            programming: "C#",
            database: "",
        },
        website: "",
        githubLink: "",
        demoLink: "https://www.youtube.com/embed/stoOfB3uRE8",
        credits: [
            {
                displayName: "Smooth Portal Effect Tutorial",
                sourceLink: "https://youtu.be/cuQao3hEKfs"
            },
            {
                displayName: "Leap Motion Controller SDK",
                sourceLink: "https://developer.leapmotion.com/sdk-leap-motion-controller/"
            }
        ]
    },
    {
        title: "AR Web Application",
        description: "A mini application of AR web app",
        url: "/portfolio/ARWebApp",
        period: "March 2020 - March 2020 (1 week)",
        images:[
            "images/portfolio/webarapp/MainPage.png",
            "images/portfolio/webarapp/ARDisplay.png",
        ],
        category: "AR Application",
        mode: "Group",
        teamMember: [
            "Goh Chiang Cheng (Programmer)",
            "Steven Yong Wei (Resource Assistant)",
            "Chai Cheah Wen (Documentation Assistant)"
        ],
        features: [
            "User upload the Marker",
            "Extract Feature from the Marker and save into PATT format",
            "Visualize AR Display on Top of the Marker"
        ],
        tools: {
            core: "AR.js, Three.js",
            programming: "Javascript",
            database: "",
        },
        website: "",
        githubLink: "",
        demoLink: "https://www.youtube.com/embed/tTdjDUcVx6Q",
        credits: [
            {
                displayName: "AR.js",
                sourceLink: "https://github.com/jeromeetienne/AR.js"
            },
            {
                displayName: "AR.js & Three.js",
                sourceLink: "https://kalwalt.github.io/kalwalt-interactivity-AR/index.html"
            }
        ]
    },
    {
        title: "Tower Builder",
        description: "Simple game developed using C++",
        url: "/portfolio/TowerBuilder",
        period: "March 2018 - May 2018 (3 months)",
        images:[
            "images/portfolio/towerbuilder/MainPage.png",
            "images/portfolio/towerbuilder/Gameplay.png",
            "images/portfolio/towerbuilder/Win.png",
            "images/portfolio/towerbuilder/Lose.png",
        ],
        category: "2D Game",
        mode: "Group",
        teamMember: [
            "Goh Chiang Cheng (Game Programmer)",
            "Chai Cheah Wen (Game Designer)",
            "Ngieng Chai Wen (Game Artist)"
        ],
        features: [
            "There are 40 Towers, player need to place all the tower within 60 seconds",
            "Place tower on top of each other",
            "There is 3 Lifes, used whenever a tower miss",
            "Perfect Match (30 Score Earned + 2 Seconds Earned), Good (10 Score Earned + 2 Seconds Earned), Hold (5 Score earned), Alert (1 Life Lose)",
            "Bonus rate increase by 1 for each \"Perfect\" Score",
            "Game Over if Lose All the Lifes or Not Finish within Time Limit",
            "Game Win if All the Towers place within Time Limit with Life greater than 0"
        ],
        tools: {
            core: "WinBGIm",
            programming: "C++",
            database: "",
        },
        website: "",
        githubLink: "",
        demoLink: "https://www.youtube.com/embed/11ox8Xnr2LA",
        credits: [
        ]
    },
    {
        title: "Tic Tac Toe",
        description: "Simple game developed using C++ with Minimax Algorithm",
        url: "/portfolio/TicTacToe",
        period: "Nov 2019 - Dec 2020 (1 month)",
        images:[
            "images/portfolio/tictactoe/MainPage.png",
            "images/portfolio/tictactoe/Gameplay.png",
            "images/portfolio/tictactoe/Draw.png",
            "images/portfolio/tictactoe/Lose.png",
        ],
        category: "2D Game",
        mode: "Group",
        teamMember: [
            "Chai Cheah Wen (Game Programmer)",
            "Goh Chiang Cheng (Game Programmer)",
            "Lim Bao Jing (Documentation Assistant)",
            "Low Chia Jing (Documentation Assistant)",
            "Tan See Jou (2D Game Artist)"
        ],
        features: [
            "3x3 Grid Base",
            "2 Players which are Computer and Me",
            "Minimax algorithm apply on Computer, finding the Best path on win the game",
            "It is not possible for Me to win the game, either Game Lose or Game Draw"
        ],
        tools: {
            core: "WinBGIm",
            programming: "C++",
            database: "",
        },
        website: "",
        githubLink: "",
        demoLink: "https://www.youtube.com/embed/acefqOxaam4",
        credits: [
        ]
    },
    {
        title: "How Fast You Are",
        description: "A mini game developed using Unity3D",
        url: "/portfolio/HowFastYouAre",
        period: "April 2021 - May 2021 (1 month)",
        images:[
            "images/portfolio/howfastyouare/MainPage.png",
            "images/portfolio/howfastyouare/Lobby.png",
            "images/portfolio/howfastyouare/Leaderboard.png",
            "images/portfolio/howfastyouare/Badge.png",
            "images/portfolio/howfastyouare/Levels.png",
            "images/portfolio/howfastyouare/Gameplay.png",
            "images/portfolio/howfastyouare/Win.png",
            "images/portfolio/howfastyouare/Lose.png",
        ],
        category: "3D Game",
        mode: "Group",
        teamMember: [
            "Chai Cheah Wen (Game Programmer)",
            "Goh Chiang Cheng (Game Designer)",
            "Ngieng Chai Wen (Game Artist)"
        ],
        features: [
            "Single Player",
            "Facebook Login",
            "Gamification using Tenenet",
            "4 Types of Obstacles (Ground Needle, Moving Saw, Spinning Blade, Flying Kunai)",
            "3 Collectable Items (Heal Potion, Protection Shield, Time Frozen Hourglass)",
            "3 Unlockable Levels (Easy, Medium, Hard)",
            "Support both Android and Window Desktop platform",
            "Character control (WASD for Desktop, Joystick for Mobile)",
            "Cross the dungeon and avoid getting hit by the Obstacles"
        ],
        tools: {
            core: "Unity3D, FacebookSDK",
            programming: "C#",
            database: "",
        },
        website: "",
        githubLink: "",
        demoLink: "https://drive.google.com/file/d/1lyLO23sn9-Umin4z_EcPk-BNsmbiM0cD/preview",
        credits: [
            {
                displayName: "FacebookSDK For Unity",
                sourceLink: "https://developers.facebook.com/docs/unity/"
            },
            {
                displayName: "Shield",
                sourceLink: "https://assetstore.unity.com/packages/3d/props/weapons/shield-61351"
            },
            {
                displayName: "Sand Clock",
                sourceLink: "https://assetstore.unity.com/packages/3d/props/interior/sand-clock-8466"
            },
            {
                displayName: "Simple Health Heart System",
                sourceLink: "https://assetstore.unity.com/packages/tools/gui/simple-heart-health-system-120676"
            },
            {
                displayName: "Joystick Pack",
                sourceLink: "https://assetstore.unity.com/packages/tools/input-management/joystick-pack-107631"
            },
            {
                displayName: "Flat Texture",
                sourceLink: "https://assetstore.unity.com/packages/2d/textures-materials/flat-textures-demo-141275"
            },
            {
                displayName: "Dungeon Traps",
                sourceLink: "https://assetstore.unity.com/packages/3d/environments/dungeons/dungeon-traps-50655"
            },
            {
                displayName: "Fantastic Skybox",
                sourceLink: "https://assetstore.unity.com/packages/2d/textures-materials/sky/fantasy-skybox-free-18353"
            },
            {
                displayName: "Supercyan Character Pack Free Sample",
                sourceLink: "https://assetstore.unity.com/packages/3d/characters/humanoids/character-pack-free-sample-79870"
            }
        ]
    },
    {
        title: "Working Cells",
        description: "A multiplayer game developed using Unity3D, Photon 2 & Tenenet gamification",
        url: "/portfolio/WorkingCells",
        period: "April 2021 - June 2021 (2 month)",
        images:[
            "images/portfolio/workingcells/MainPage.png",
            "images/portfolio/workingcells/Story.png",
            "images/portfolio/workingcells/Characters.png",
            "images/portfolio/workingcells/Cell.png",
            "images/portfolio/workingcells/Enemy.png",
            "images/portfolio/workingcells/Items.png",
            "images/portfolio/workingcells/Leaderboard.png",
            "images/portfolio/workingcells/Badge.png",
            "images/portfolio/workingcells/RoomList.png",
            "images/portfolio/workingcells/RoomScene.png",
            "images/portfolio/workingcells/Loading.png",
            "images/portfolio/workingcells/Gameplay.png",
            "images/portfolio/workingcells/Gameplay2.png",
            "images/portfolio/workingcells/Lose.png"
        ],
        category: "3D Multiplayer Game",
        mode: "Group",
        teamMember: [
            "Chai Cheah Wen (Game Programmer)",
            "Goh Chiang Cheng (Game Designer)",
            "Ngieng Chai Wen (Game Artist)"
        ],
        features: [
            "Educational Game for student under STEM category",
            "Game Theme related to Human Blood Cell",
            "Facebook Login",
            "Game Story with Lure",
            "Learning Corner",
            "Maximum 3 players in the Room",
            "Chatting System",
            "1 NPC which are Cell",
            "3 Character Roles which are White Blood Cell, Red Blood Cell and Platelet",
            "Main Enemies are Virus, Scar and Hypoxia Cell",
            "Role can be transformed which require 5 seconds time",
            "Game Mission is to kill all the viruses, clot all the scars and recover all the hypoxia cell within 20 minutes time",
            "Game Lose if existing hypoxia cell is greater than 20 or the existing viruses is greater than 100 or the existing scar is greating than 20 or player do not finish the game within Time Limit",
            "10 Quizzes related to Blood Cell is embedded into the game, answer correctly to earn high score",
            "Gamification with Leaderboard and Badges"
        ],
        tools: {
            core: "Unity3D, PUN 2, Tenenet",
            programming: "C#",
            database: "",
        },
        website: "",
        githubLink: "",
        demoLink: "https://drive.google.com/file/d/1Gjmx1XZqOxOoL2QiN2o_2ilGoGi3b-uD/preview",
        credits: [
            {
                displayName: "FacebookSDK For Unity",
                sourceLink: "https://developers.facebook.com/docs/unity/"
            },
            {
                displayName: "PUN 2",
                sourceLink: "https://assetstore.unity.com/packages/tools/network/pun-2-free-119922"
            },
            {
                displayName: "Tenenet Gamification",
                sourceLink: "https://tenenet.net/tenenet-gami/public/"
            },
            {
                displayName: "Fantastic Skybox",
                sourceLink: "https://assetstore.unity.com/packages/2d/textures-materials/sky/fantasy-skybox-free-18353"
            },
            {
                displayName: "Supercyan Character Pack Free Sample",
                sourceLink: "https://assetstore.unity.com/packages/3d/characters/humanoids/character-pack-free-sample-79870"
            },
            {
                displayName: "Basic RPG Cursors",
                sourceLink: "https://assetstore.unity.com/packages/2d/textures-materials/basic-rpg-cursors-139404"
            },
            {
                displayName: "Mini Fantasy Pack",
                sourceLink: "https://assetstore.unity.com/packages/3d/props/mini-fantasy-pack-177462"   
            },
            {
                displayName: "Flag",
                sourceLink: "https://assetstore.unity.com/packages/3d/props/exterior/cloth-animation-based-flag-65842"
            },
            {
                displayName: "Free Mummy Monster",
                sourceLink: "https://assetstore.unity.com/packages/3d/characters/free-mummy-monster-134212"
            },
            {
                displayName: "Stone Monster",
                sourceLink: "https://assetstore.unity.com/packages/3d/characters/stone-monster-101433"
            },
            {
                displayName: "Stylized Hammer",
                sourceLink: "https://assetstore.unity.com/packages/3d/props/tools/stylized-hammer-162874"
            },
            {
                displayName: "Energy Cells Free",
                sourceLink: "https://assetstore.unity.com/packages/3d/environments/sci-fi/energy-cells-free-166830"
            },
            {
                displayName: "Sine VFX",
                sourceLink: "https://assetstore.unity.com/packages/3d/environments/fantasy/translucent-crystals-106274"
            }
        ]
    },
    {
        title: "An Apple A Day Keep The Doctor Away",
        description: "A random Unity game from my random mind",
        url: "/portfolio/AnAppleADayKeepTheDoctorAway",
        period: "July 2021 - July 2021 (3 days)",
        images:[
            "images/portfolio/anappleadaykeepthedoctoraway/MainPage.png",
            "images/portfolio/anappleadaykeepthedoctoraway/Gameplay.png",
            "images/portfolio/anappleadaykeepthedoctoraway/Lose.png",
        ],
        category: "3D Game",
        mode: "Personal",
        teamMember: [
            "Chai Cheah Wen"
        ],
        features: [
            "Collect apples as much as possible",
            "When power up, gain ability to Push Doctor Away",
            "When not power up, avoid being pushed by Doctor"
        ],
        tools: {
            core: "Unity3D",
            programming: "C#",
            database: "",
        },
        website: "",
        githubLink: "",
        demoLink: "https://www.youtube.com/embed/KIZxouKrysQ",
        credits: [
            {
                displayName: "Survival Kit Lite",
                sourceLink: "https://assetstore.unity.com/packages/3d/props/tools/survival-kit-lite-92549"
            },
            {
                displayName: "Outline Shader",
                sourceLink: "http://wiki.unity3d.com/index.php/Silhouette-Outlined_Diffuse"
            },
            {
                displayName: "Mixamo Animation",
                sourceLink: "https://www.mixamo.com/#/?page=1&type=Motion%2CMotionPack"
            }
        ]
    },
    {
        title: "3D Street Scene",
        description: "A walkthrough scene with raining and fog post processing using Unity3D",
        url: "/portfolio/3DStreetScene",
        period: "July 2021 - July 2021 (1 day)",
        images:[
            "images/portfolio/UnityRaining.png"
        ],
        category: "3D Game",
        mode: "Personal",
        teamMember: [
            "Chai Cheah Wen"
        ],
        features: [
            "Scene Walkthrough",
            "Fog Post Processing",
            "Raining Effect"
        ],
        tools: {
            core: "Unity3D",
            programming: "C#",
            database: "",
        },
        website: "",
        githubLink: "",
        demoLink: "https://www.youtube.com/embed/YI_MECppdsY",
        credits: [
            {
                displayName: "Standard Asset Unity",
                sourceLink: "https://assetstore.unity.com/packages/essentials/asset-packs/standard-assets-for-unity-2018-4-32351"
            },
            {
                displayName: "Rain Maker",
                sourceLink: "https://assetstore.unity.com/packages/vfx/particles/environment/rain-maker-2d-and-3d-rain-particle-system-for-unity-34938"
            },
            {
                displayName: "Cartoon Low Poly City Pack Lite",
                sourceLink: "https://assetstore.unity.com/packages/3d/environments/urban/cartoon-low-poly-city-pack-lite-166617"
            },
            {
                displayName: "Stylized Trees (Low Poly)",
                sourceLink: "https://assetstore.unity.com/packages/3d/vegetation/trees/stylized-trees-low-poly-49916"
            }
        ]
    },
    {
        title: "Rat & Ice Cream",
        description: "3D modelling using Blender",
        url: "/portfolio/RatIceCream",
        period: "March 2019 - March 2019 (1 week)",
        images:[
            "images/portfolio/raticecream/MainPage.png",
            "images/portfolio/raticecream/Scene.png",
        ],
        category: "3D Model",
        mode: "Group",
        teamMember: [
            "Chai Cheah Wen (3D Artist)",
            "Goh Chiang Cheng (Presenter)",
            "Siti Nurazaline (Documentation Assistant)",
            "Nurhafiyah Hazwani (Video Assistant)"
        ],
        features: [
            "Apply 3D modelling techniques such as Extrude, Bevel, Inset, Loop Cut, Knife, Loop Tools, Curve, etc",
            "Rat Model",
            "Ice Model",
            "Flower Model",
            "Grass Model",
            "Ground Sculpture"
        ],
        tools: {
            core: "Blender",
            programming: "",
            database: "",
        },
        website: "",
        githubLink: "",
        demoLink: "https://www.youtube.com/embed/7m1wnwdn7ac",
        credits: [
        ]
    },
    {
        title: "Fruit Classification using CNN",
        description: "3D modelling using Blender",
        url: "/portfolio/RatIceCream",
        period: "March 2019 - March 2019 (1 week)",
        images:[
            "images/portfolio/raticecream/MainPage.png",
            "images/portfolio/raticecream/Scene.png",
        ],
        category: "Machine Learning",
        mode: "Group",
        teamMember: [
            "Chai Cheah Wen (3D Artist)",
            "Goh Chiang Cheng (Presenter)",
            "Siti Nurazaline (Documentation Assistant)",
            "Nurhafiyah Hazwani (Video Assistant)"
        ],
        features: [
            "Apply 3D modelling techniques such as Extrude, Bevel, Inset, Loop Cut, Knife, Loop Tools, Curve, etc",
            "Rat Model",
            "Ice Model",
            "Flower Model",
            "Grass Model",
            "Ground Sculpture"
        ],
        tools: {
            core: "Blender",
            programming: "",
            database: "",
        },
        website: "",
        githubLink: "",
        demoLink: "https://www.youtube.com/embed/7m1wnwdn7ac",
        credits: [
        ]
    },
]
export default portfolioData